import { render, staticRenderFns } from "./logo-choice.vue?vue&type=template&id=1367c88e&scoped=true"
import script from "./logo-choice.vue?vue&type=script&lang=js"
export * from "./logo-choice.vue?vue&type=script&lang=js"
import style0 from "./logo-choice.vue?vue&type=style&index=0&id=1367c88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367c88e",
  null
  
)

export default component.exports